module.exports = __webpack_public_path__ + "img/alvaro.79b183e3.jpeg";